const IconFourthStep = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="106.583"
      height="89.763"
      viewBox="0 0 106.583 89.763"
    >
      <g id="undraw_order_delivered_re_v4ab" transform="translate(-16.437 -9.739)">
        <path
          id="Trazado_667"
          data-name="Trazado 667"
          d="M8.289,27.129A4.082,4.082,0,0,0,5.4,29.836c-.378,1.541.493,3.095.619,4.677C6.426,39.7-.949,43.356.1,48.449c.418,2.025,2.106,3.515,3.77,4.745a20.526,20.526,0,0,0,8.9,4.191c4.971.745,10.165-1.444,15-.061,3.9,1.116,6.88,4.387,10.75,5.594,2.946.919,6.12.557,9.181.185a9.67,9.67,0,0,0,4.711-1.422c2.476-1.843,2.632-5.484,4.289-8.093,2.56-4.023,8.174-4.813,12.881-4.031s9.278,2.707,14.047,2.55a6.411,6.411,0,0,0,2.952-.673A7.325,7.325,0,0,0,89.038,48.7a44.3,44.3,0,0,0,6.424-22.013,7.9,7.9,0,0,0-.648-3.909,7.143,7.143,0,0,0-3.962-2.984c-3.8-1.444-7.987-1.68-11.706-3.309-3.587-1.571-6.492-4.326-9.615-6.688A51.216,51.216,0,0,0,48.435.4,13.373,13.373,0,0,0,43,.206a12.891,12.891,0,0,0-5.416,3.119c-4.235,3.666-7.628,8.19-11.531,12.208a65.649,65.649,0,0,1-8.76,7.554A31.924,31.924,0,0,1,12.7,26.134C11.228,26.837,9.847,26.66,8.289,27.129Z"
          transform="matrix(-0.978, 0.208, -0.208, -0.978, 123.02, 71.849)"
          fill="rgba(133,196,64,0.5)"
          opacity="0.2"
        />
        <path
          id="Trazado_627"
          data-name="Trazado 627"
          d="M438.05,412.576c-.988-5.288.568-11.3,4.891-14.5a24.786,24.786,0,0,0,5.167,16.214c1.388,1.779,3.117,3.613,3.063,5.868a5.54,5.54,0,0,1-1.793,3.7,16.456,16.456,0,0,1-3.45,2.394l-.189.295C442.171,422.513,439.038,417.864,438.05,412.576Z"
          transform="translate(-404.976 -357.718)"
          fill="#fff"
        />
        <path
          id="Trazado_628"
          data-name="Trazado 628"
          d="M455.7,397.744a21.185,21.185,0,0,0-1.4,12.959,9.121,9.121,0,0,0,.966,2.69,5.233,5.233,0,0,0,1.977,1.917,10.831,10.831,0,0,1,2.212,1.406,3.2,3.2,0,0,1,.943,2.445,8.324,8.324,0,0,1-.922,3.181,8.173,8.173,0,0,0-1.023,3.536c0,.153-.233.15-.237,0-.057-2.192,1.527-3.952,1.88-6.055a3.245,3.245,0,0,0-.655-2.779,8.4,8.4,0,0,0-2.219-1.471,5.583,5.583,0,0,1-2-1.8,8.436,8.436,0,0,1-1.066-2.643,20.553,20.553,0,0,1-.466-6.407,21.561,21.561,0,0,1,1.808-7.1C455.558,397.483,455.761,397.606,455.7,397.744Z"
          transform="translate(-417.655 -357.31)"
          fill="#fff"
        />
        <path
          id="Trazado_629"
          data-name="Trazado 629"
          d="M441.9,445.978a3.178,3.178,0,0,1-3.316-2.438c-.035-.149.195-.209.229-.061a2.943,2.943,0,0,0,3.089,2.261C442.054,445.729,442.051,445.966,441.9,445.978Z"
          transform="translate(-405.629 -393.971)"
          fill="#fff"
        />
        <path
          id="Trazado_630"
          data-name="Trazado 630"
          d="M469.565,468.2a6.126,6.126,0,0,0,1.535-4.192c0-.153.234-.15.237,0a6.372,6.372,0,0,1-1.607,4.359C469.629,468.483,469.464,468.313,469.565,468.2Z"
          transform="translate(-430.388 -410.369)"
          fill="#fff"
        />
        <path
          id="Trazado_631"
          data-name="Trazado 631"
          d="M455.856,419.264a1.8,1.8,0,0,0,1.6-.6c.1-.115.265.055.166.169a2.016,2.016,0,0,1-1.767.668.123.123,0,0,1-.117-.12.119.119,0,0,1,.12-.117Z"
          transform="translate(-419.352 -374.159)"
          fill="#fff"
        />
        <path
          id="Trazado_632"
          data-name="Trazado 632"
          d="M491.771,419.929c-.06.074-.121.148-.181.224a23.7,23.7,0,0,0-2.168,3.173c-.051.085-.1.173-.148.259a24.98,24.98,0,0,0-2.915,8.722,24.262,24.262,0,0,0-.222,3.679,15.79,15.79,0,0,1-.33,5.1,4.15,4.15,0,0,1-.187.48l-8.357,2.663-.066-.008-.329.122c-.005-.063-.01-.129-.015-.193,0-.037,0-.074-.008-.111s0-.049-.006-.072,0-.016,0-.023c0-.022,0-.043-.005-.063-.025-.368-.048-.737-.067-1.106,0,0,0,0,0,0a35.668,35.668,0,0,1,.468-8.419c.016-.083.031-.167.05-.251a23.153,23.153,0,0,1,1.024-3.636,20.461,20.461,0,0,1,.825-1.9,17.018,17.018,0,0,1,3.089-4.332,13.512,13.512,0,0,1,9.281-4.3C491.592,419.929,491.68,419.929,491.771,419.929Z"
          transform="translate(-436.124 -375.202)"
          fill="#fff"
        />
        <path
          id="Trazado_633"
          data-name="Trazado 633"
          d="M492.3,419.552a21.185,21.185,0,0,0-8.919,9.505,9.123,9.123,0,0,0-.848,2.73,5.232,5.232,0,0,0,.424,2.721,10.831,10.831,0,0,1,.92,2.455,3.2,3.2,0,0,1-.719,2.52,8.325,8.325,0,0,1-2.652,1.985,8.173,8.173,0,0,0-2.946,2.207c-.089.124-.276-.021-.188-.145,1.274-1.785,3.6-2.236,5.147-3.7a3.245,3.245,0,0,0,1.15-2.613,8.4,8.4,0,0,0-.886-2.51,5.584,5.584,0,0,1-.514-2.645,8.433,8.433,0,0,1,.74-2.752,20.555,20.555,0,0,1,3.485-5.4,21.56,21.56,0,0,1,5.716-4.578c.133-.074.222.147.089.22Z"
          transform="translate(-436.643 -374.713)"
          fill="#fff"
        />
        <path
          id="Trazado_634"
          data-name="Trazado 634"
          d="M504.388,445.289a3.178,3.178,0,0,1-1.18-3.943c.062-.139.281-.05.22.09a2.943,2.943,0,0,0,1.1,3.666C504.661,445.184,504.516,445.371,504.388,445.289Z"
          transform="translate(-457.11 -392.277)"
          fill="#fff"
        />
        <path
          id="Trazado_635"
          data-name="Trazado 635"
          d="M503.858,483.436a6.126,6.126,0,0,0,3.75-2.423c.089-.124.277.021.188.145a6.372,6.372,0,0,1-3.907,2.513c-.15.03-.18-.205-.03-.235Z"
          transform="translate(-457.766 -424.025)"
          fill="#fff"
        />
        <path
          id="Trazado_636"
          data-name="Trazado 636"
          d="M531.116,434.4a1.8,1.8,0,0,0,1.637.483c.149-.032.179.2.03.235a2.016,2.016,0,0,1-1.813-.53.123.123,0,0,1-.021-.166A.119.119,0,0,1,531.116,434.4Z"
          transform="translate(-479.496 -386.754)"
          fill="#fff"
        />
        <path
          id="Trazado_648"
          data-name="Trazado 648"
          d="M450.5,515.522a1.894,1.894,0,0,0-1.59-1.857L421.729,509.2a1.894,1.894,0,0,0-.783.035l-6.369,1.647-3.654.946-6.744,1.743a1.9,1.9,0,0,0-1.422,1.838v28.478a1.908,1.908,0,0,0,1.5,1.856l27.682-.313a1.84,1.84,0,0,0,.4.041,1.9,1.9,0,0,0,.571-.087l16.446.409a1.89,1.89,0,0,0,1.327-1.826Z"
          transform="translate(-376.973 -446.59)"
          fill="#fff"
        />
        <path
          id="Trazado_649"
          data-name="Trazado 649"
          d="M450.5,515.522a1.894,1.894,0,0,0-1.59-1.857L421.729,509.2a1.894,1.894,0,0,0-.783.035l-6.369,1.647-3.654.946-6.744,1.743a1.9,1.9,0,0,0-1.422,1.838v28.478a1.908,1.908,0,0,0,1.5,1.856l27.682-.313a1.84,1.84,0,0,0,.4.041,1.9,1.9,0,0,0,.571-.087l16.446.409a1.89,1.89,0,0,0,1.327-1.826Zm-1.285,29.82-16.446.391a1.444,1.444,0,0,1-.725.035l-27.683-.487a1.431,1.431,0,0,1-1.126-1.392V515.411a1.425,1.425,0,0,1,.933-1.337,1.2,1.2,0,0,1,.133-.041l7.135-1.845,4.219-1.092,5.414-1.4a1.356,1.356,0,0,1,.356-.046,1.411,1.411,0,0,1,.231.019l27.177,4.463a1.417,1.417,0,0,1,1.193,1.392l.185,28.447a1.419,1.419,0,0,1-1,1.37Z"
          transform="translate(-376.973 -446.59)"
          fill="#ccc"
        />
        <path
          id="Trazado_650"
          data-name="Trazado 650"
          d="M452.073,534.027a.207.207,0,0,1-.06.027l-7.994,2.161-2.488.672-7.078,1.913a.273.273,0,0,1-.062.008l-.043,0-28.539-5.2-.095-.017a.238.238,0,1,1,.085-.468l.574.1,28.008,5.107,6.1-1.648,3.412-.922,7.87-2.128.125-.033a.239.239,0,0,1,.277.13.187.187,0,0,1,.014.038A.238.238,0,0,1,452.073,534.027Z"
          transform="translate(-379.183 -465.737)"
          fill="#ccc"
        />
        <path
          id="Trazado_651"
          data-name="Trazado 651"
          d="M549.093,585.545c-.13,0-.236-.1-.237.565l-.237-25.866c0-.931.1-1.039.235-1.04h0c.13,0,.236.1.237,1.036l.237,25.866c0-.669-.1-.562-.235-.561Z"
          transform="translate(-493.648 -486.608)"
          fill="#ccc"
        />
        <path
          id="Trazado_652"
          data-name="Trazado 652"
          d="M474.52,552.652l-2.556.027-1.049-28.322-26.763-5.325a.615.615,0,0,1-.077-.019.944.944,0,0,1-.509-.359l3.654-.946,1.074.214,25.394,5.051a.944.944,0,0,1,.639.462C474.407,523.572,474.519,552.487,474.52,552.652Z"
          transform="translate(-409.617 -453.414)"
          fill="#ccc"
        />
        <path
          id="Trazado_661"
          data-name="Trazado 661"
          d="M394.014,691.474H290.862a.242.242,0,0,1,0-.477H394.014a.242.242,0,0,1,0,.477Z"
          transform="translate(-274.226 -592.028)"
          fill="#cacaca"
        />
        <circle
          id="Elipse_75"
          data-name="Elipse 75"
          cx="7.166"
          cy="7.166"
          r="7.166"
          transform="translate(20.222 59.797)"
          fill="#85c440"
        />
        <path
          id="Trazado_662"
          data-name="Trazado 662"
          d="M394.889,519.87a.8.8,0,0,1-.638-.319l-1.955-2.607a.8.8,0,0,1,1.275-.956l1.279,1.705,3.285-4.927a.8.8,0,1,1,1.326.884l-3.91,5.865a.8.8,0,0,1-.641.355Z"
          transform="translate(-368.479 -449.178)"
          fill="#fff"
        />
        <g id="Grupo_140" data-name="Grupo 140" transform="translate(54.231 14.352)">
          <path
            id="Trazado_637"
            data-name="Trazado 637"
            d="M598.1,267.8a2.083,2.083,0,0,1,.048.327l8.552,4.934,2.079-1.2,2.216,2.9-3.474,2.476a1.593,1.593,0,0,1-1.911-.047l-8.818-6.957A2.09,2.09,0,1,1,598.1,267.8Z"
            transform="translate(-581.192 -255.735)"
            fill="#ffb6b6"
          />
          <path
            id="Trazado_638"
            data-name="Trazado 638"
            d="M667.416,287.039a.894.894,0,0,1,.447-.6l3.948-2.151a2.488,2.488,0,1,1,3.008,3.964l-3.164,3.215a.9.9,0,0,1-1.354-.089l-2.724-3.612a.9.9,0,0,1-.161-.729Z"
            transform="translate(-641.784 -270.258)"
            fill="#3f3d56"
          />
          <path
            id="Trazado_639"
            data-name="Trazado 639"
            d="M706.767,210.612a6.171,6.171,0,0,1,3.646-4.083c1.787-.612,4.4.32,5.746,1.659,2.457,2.449,3.056,10.86,1.368,13.519-.336-.018-1.494-.031-1.834-.044l-.481-1.6v1.586c-2.652-.082-5.414-.031-8.177.022C706.789,219.788,706.2,212.423,706.767,210.612Z"
            transform="translate(-674.082 -206.338)"
            fill="#2f2e41"
          />
          <path
            id="Trazado_640"
            data-name="Trazado 640"
            d="M396.013,415.477h-2.419l-1.151-9.331h3.57Z"
            transform="translate(-364.088 -335.211)"
            fill="#ffb6b6"
          />
          <path
            id="Trazado_641"
            data-name="Trazado 641"
            d="M506.689,408.29l-2.341.61-3.467-8.739,3.455-.9Z"
            transform="translate(-453.587 -329.529)"
            fill="#ffb6b6"
          />
          <path
            id="Trazado_642"
            data-name="Trazado 642"
            d="M409.181,126.251l.548,1.425-.11,1.425-10.728,3.716.532-6.237,1.206-1.425Z"
            transform="translate(-369.411 -103.296)"
            fill="#ffb6b6"
          />
          <circle
            id="Elipse_74"
            data-name="Elipse 74"
            cx="3.832"
            cy="3.832"
            r="3.832"
            transform="translate(32.547 2.467)"
            fill="#ffb7b7"
          />
          <path
            id="Trazado_643"
            data-name="Trazado 643"
            d="M703.078,210.507a4.813,4.813,0,0,1,7.317,4.2,12.929,12.929,0,0,1-6.673.129l-.539-1.32-.318,1.321a1.621,1.621,0,0,1-2.089,0A4.914,4.914,0,0,1,703.078,210.507Z"
            transform="translate(-669.333 -209.198)"
            fill="#2f2e41"
          />
          <path
            id="Trazado_644"
            data-name="Trazado 644"
            d="M670.121,663.786H668.4l-.306-1.621-.785,1.621H662.76a1.023,1.023,0,0,1-.582-1.866l3.636-2.511v-1.639l3.824.228Z"
            transform="translate(-637.114 -578.926)"
            fill="#2f2e41"
          />
          <path
            id="Trazado_645"
            data-name="Trazado 645"
            d="M798.928,654.981l-1.661.433-.705-1.491-.351,1.766-4.406,1.148a1.023,1.023,0,0,1-1.033-1.659l2.885-3.347-.413-1.585L797,649.5Z"
            transform="translate(-743.408 -572.102)"
            fill="#2f2e41"
          />
          <path
            id="Trazado_646"
            data-name="Trazado 646"
            d="M702.728,418.612l-7.091-14.574L693.411,386.3c1.535-2.85-1.316-8.65-1.316-8.65v-2.435L681.054,377.3h0a53,53,0,0,0-3.23,19.245l.445,23.58h-.14a.873.873,0,0,0,0,1.747H682.5a.873.873,0,0,0,0-1.747h-.113l3.135-30,3.645,14.8,8.808,13.63a.871.871,0,0,0,.07,1.74h4.366a.872.872,0,0,0,.322-1.683Z"
            transform="translate(-649.923 -345.718)"
            fill="#abdb40"
          />
          <path
            id="Trazado_647"
            data-name="Trazado 647"
            d="M698.21,296.668h0a.7.7,0,0,0-.63-.523c-.146-1.664-1.107-12.336-1.144-12.649v-.013l-.279-5.948a.879.879,0,0,0-.821-.837l-1.471-.1a.078.078,0,0,1-.075-.078,1.237,1.237,0,0,0-1.237-1.237H688.2a1.158,1.158,0,0,0-1.148,1.014.077.077,0,0,1-.078.069h0a2.069,2.069,0,0,0-2.081,1.716c-.6,3.464-1.788,11.325-1.2,15.695a30.638,30.638,0,0,1,.034,5.082.937.937,0,0,0,.233.679.7.7,0,0,0-.483.84h0a.7.7,0,0,0,.848.507l13.379-3.373A.7.7,0,0,0,698.21,296.668Z"
            transform="translate(-655.039 -263.245)"
            fill="#3f3d56"
          />
          <path
            id="Trazado_653"
            data-name="Trazado 653"
            d="M552.159,262.1a1.246,1.246,0,0,0-1.046-1.222l-17.877-2.936a1.244,1.244,0,0,0-.515.023l-4.19,1.083-2.4.622-4.436,1.147a1.25,1.25,0,0,0-.936,1.209v14.652a1.255,1.255,0,0,0,.989,1.221l18.209,3.874a1.212,1.212,0,0,0,.26.027,1.247,1.247,0,0,0,.376-.057l10.818-3.416a1.244,1.244,0,0,0,.873-1.2Z"
            transform="translate(-520.756 -248.918)"
            fill="#fff"
          />
          <path
            id="Trazado_654"
            data-name="Trazado 654"
            d="M538.2,264.184a.15.15,0,0,0-.039,0l-11.03,2.852a.156.156,0,0,0-.117.151v14.652a.157.157,0,0,0,.123.153l18.209,3.874a.157.157,0,0,0,.079,0l10.819-3.416a.155.155,0,0,0,.109-.15l-.121-15.027a.156.156,0,0,0-.131-.153l-17.877-2.936Z"
            transform="translate(-525.92 -254.081)"
            fill="#85c440"
          />
          <path
            id="Trazado_655"
            data-name="Trazado 655"
            d="M552.159,262.1a1.246,1.246,0,0,0-1.046-1.222l-17.877-2.936a1.244,1.244,0,0,0-.515.023l-4.19,1.083-2.4.622-4.436,1.147a1.25,1.25,0,0,0-.936,1.209v14.652a1.255,1.255,0,0,0,.989,1.221l18.209,3.874a1.212,1.212,0,0,0,.26.027,1.247,1.247,0,0,0,.376-.057l10.818-3.416a1.244,1.244,0,0,0,.873-1.2Zm-.845,15.93L540.5,281.448a.949.949,0,0,1-.477.023l-18.21-3.874a.941.941,0,0,1-.741-.916V262.029a.938.938,0,0,1,.614-.879.769.769,0,0,1,.087-.027l4.693-1.213,2.775-.718,3.561-.921a.893.893,0,0,1,.234-.03.929.929,0,0,1,.152.012l17.877,2.936a.932.932,0,0,1,.785.916l.122,15.027A.933.933,0,0,1,551.314,278.032Z"
            transform="translate(-520.756 -248.918)"
            fill="#3f3d56"
          />
          <path
            id="Trazado_656"
            data-name="Trazado 656"
            d="M553.462,276.569a.134.134,0,0,1-.039.018l-5.258,1.422-1.637.442-4.656,1.258a.18.18,0,0,1-.041.005l-.028,0-18.773-3.423-.062-.011a.157.157,0,1,1,.056-.308l.378.069,18.423,3.359,4.013-1.084,2.245-.607,5.177-1.4.082-.022a.157.157,0,0,1,.182.085.121.121,0,0,1,.009.025A.157.157,0,0,1,553.462,276.569Z"
            transform="translate(-522.475 -263.806)"
            fill="#3f3d56"
          />
          <path
            id="Trazado_657"
            data-name="Trazado 657"
            d="M631,312.959a.156.156,0,0,1-.156-.155l-.156-17.014a.156.156,0,0,1,.155-.158h0a.156.156,0,0,1,.156.155l.156,17.014a.156.156,0,0,1-.155.158Z"
            transform="translate(-611.487 -280.037)"
            fill="#3f3d56"
          />
          <path
            id="Trazado_658"
            data-name="Trazado 658"
            d="M571.83,285.077l-1.637.442-.69-16.788-17.6-3.5a.407.407,0,0,1-.051-.012.621.621,0,0,1-.335-.236l2.4-.622.707.14,16.7,3.323a.621.621,0,0,1,.42.3C571.8,268.215,571.829,284.968,571.83,285.077Z"
            transform="translate(-546.141 -254.224)"
            fill="#3f3d56"
          />
          <path
            id="Trazado_659"
            data-name="Trazado 659"
            d="M647.4,313.476a2.089,2.089,0,0,1,.233.234l9.806-1.145.954-2.2,3.509,1.005-1.31,4.06a1.593,1.593,0,0,1-1.561,1.1l-11.228-.319a2.09,2.09,0,1,1-.4-2.737Z"
            transform="translate(-622.443 -292.195)"
            fill="#ffb6b6"
          />
          <path
            id="Trazado_660"
            data-name="Trazado 660"
            d="M719.428,288.752a.9.9,0,0,1,0-.746l1.884-4.082a2.488,2.488,0,0,1,4.779,1.385l-.62,4.468a.9.9,0,0,1-1.139.736l-4.342-1.272A.9.9,0,0,1,719.428,288.752Z"
            transform="translate(-684.663 -268.89)"
            fill="#3f3d56"
          />
          <path
            id="Trazado_663"
            data-name="Trazado 663"
            d="M536.432,332.584a.261.261,0,0,1-.058-.006l-5.414-1.223a.262.262,0,1,1,.115-.511l5.414,1.223a.262.262,0,0,1-.057.518Z"
            transform="translate(-529.009 -309.093)"
            fill="#fff"
          />
        </g>
        <path
          id="Trazado_664"
          data-name="Trazado 664"
          d="M417.088,619.771a.3.3,0,0,1-.066.006l-6.359-.107a.3.3,0,1,1,.01-.6l6.359.107a.3.3,0,0,1,.056.594Z"
          transform="translate(-383.062 -534.494)"
          fill="#e6e6e6"
        />
        <path
          id="Trazado_665"
          data-name="Trazado 665"
          d="M428.088,636.771a.3.3,0,0,1-.066.006l-6.359-.107a.3.3,0,1,1,.01-.6l6.359.107a.3.3,0,0,1,.056.594Z"
          transform="translate(-391.861 -548.092)"
          fill="#e6e6e6"
        />
      </g>
    </svg>
  );
};

export default IconFourthStep;
